import { useEffect, useState, useContext } from "react";
import AppContext from "../../../contexts/AppContext";
import axios from "axios";
import "../../../assets/css/seller/screens/SellerTopup.css";
import { useTheme } from "../../../contexts/ThemeContext";
import SellerMasterLayout from "../../../layouts/seller/SellerMasterLayout";
import {
  FiAlertCircle,
  FiPlusCircle,
  FiDollarSign,
  FiX,
  FiTrendingUp,
  FiTrendingDown,
  FiSearch,
  FiArrowRight,
} from "react-icons/fi";
import { Spinner } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";

const SellerEarningsManagement = () => {
  const { baseUrl, baseUrlForFiles ,sellerAuthToken } = useContext(AppContext);
  const { isDark } = useTheme();
  const navigate = useNavigate();

  const [showTopUpModal, setShowTopUpModal] = useState(false);
  const [topUpAmount, setTopUpAmount] = useState("");
  const [screenshot, setScreenshot] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [statsData, setStatsData] = useState(null);
  const [topUpHistory, setTopUpHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("All Status");

  // ── payment method dropdown (Sehar) ──
  const [paymentMethod, setPaymentMethod] = useState("bank");

  // ── shop guard modal (main) ──
  const [shopGuardModal, setShopGuardModal] = useState(false);
  const [shopGuardType, setShopGuardType] = useState("");
  const [shopStatusLoaded, setShopStatusLoaded] = useState(null);

  const STATUS_OPTIONS = ["All Status", "Approved", "Pending", "Rejected"];

  const PLATFORM_COMMISSION_PERCENT = 7;

  
  const paymentMethods = {
    bank: {
      label: "Bank Account",
      fields: [
        { label: "Bank Name", value: "Bank of Punjab" },
        { label: "Account Title", value: "Sehar Rehman" },
        { label: "Account Number", value: "6760285166300012" },
      ],
    },
    jazzcash: {
      label: "JazzCash",
      fields: [
        { label: "Account Title", value: "Nayab Qaiser" },
        { label: "Account Number", value: "0325 0015894" },
      ],
    },
    easypaisa: {
      label: "EasyPaisa",
      fields: [
        { label: "Account Title", value: "Amina Ijaz" },
        { label: "Account Number", value: "0333 8178126" },
      ],
    },
  };

  const statusClasses = {
    approved: "ser-status-success",
    pending: "ser-status-pending",
    rejected: "ser-status-warning",
  };

  const checkShop = () => {
    const seller = JSON.parse(localStorage.getItem("loggedInSeller"));
    if (!seller?.id) return;
    const formdata = new FormData();
    formdata.append("seller_id", seller.id);
    axios
      .post(`${baseUrl}/seller/store/getmystore`, formdata, 
        {
        headers: {
          "Content-Type": "multipart/form-data",
           Authorization: `Bearer ${sellerAuthToken}`,
        },
      },
      )
      .then((res) => {
        const store = res.data.store;
        if (!store?.store_name) {
          setShopStatusLoaded("no-shop");
        } else {
          setShopStatusLoaded(store.status);
        }
      })
      .catch((err) => {
        console.log("checkShop error:", err.response?.data || err.message);
      });
  };

  const handleAddTopUpClick = () => {
    if (shopStatusLoaded === "no-shop") {
      setShopGuardType("no-shop");
      setShopGuardModal(true);
      return;
    }
    if (shopStatusLoaded === "Pending") {
      setShopGuardType("pending");
      setShopGuardModal(true);
      return;
    }
    setShowTopUpModal(true);
  };

  const getFilteredHistory = () => {
    let filtered = topUpHistory;
    if (statusFilter !== "All Status") {
      filtered = filtered.filter(
        (t) => t.status?.toLowerCase() === statusFilter.toLowerCase(),
      );
    }
    if (search.trim()) {
      filtered = filtered.filter(
        (t) =>
          t.id?.toString().includes(search) ||
          t.amount?.toString().includes(search),
      );
    }
    return filtered;
  };

  const handleTopUpSubmit = () => {
    if (!topUpAmount || Number(topUpAmount) < 100) {
      alert("Minimum TopUp amount is Rs 100");
      return;
    }
    if (!screenshot) {
      alert("Please attach payment screenshot");
      return;
    }
    setSubmitting(true);
    submitTopUp();
  };

  const closeModal = () => {
    setShowTopUpModal(false);
    setTopUpAmount("");
    setScreenshot(null);
    setPaymentMethod("bank"); 
  };

  const submitTopUp = () => {
    const loggedInSeller = JSON.parse(localStorage.getItem("loggedInSeller"));
    const formdata = new FormData();
    formdata.append("seller_id", loggedInSeller?.id);
    formdata.append("amount", topUpAmount);
    formdata.append("screenshot", screenshot);
    formdata.append("payment_method", paymentMethod);

    axios
      .post(`${baseUrl}/seller/topup/submitTopUp`, formdata, {
        headers: {
          "Content-Type": "multipart/form-data",
           Authorization: `Bearer ${sellerAuthToken}`,
        },
      },)
      .then(() => {
        toast.success("TopUp Request Submitted");
        viewAllTopUps();
        setSubmitting(false);
        closeModal();
      })
      .catch((error) => {
        console.error(error);
        setSubmitting(false);
      });
  };

  const viewAllTopUps = () => {
    setLoading(true);
    const loggedInSeller = JSON.parse(localStorage.getItem("loggedInSeller"));
    const formdata = new FormData();
    formdata.append("seller_id", loggedInSeller?.id);

    axios
      .post(`${baseUrl}/seller/topup/viewAllTopUps`, formdata, 
        {
        headers: {
          "Content-Type": "multipart/form-data",
           Authorization: `Bearer ${sellerAuthToken}`,
        },
      },
      )
      .then((response) => {
        setTopUpHistory(response.data.topups ?? []);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  const getStats = () => {
    const loggedInSeller = JSON.parse(localStorage.getItem("loggedInSeller"));
    const fd = new FormData();
    fd.append("seller_id", loggedInSeller?.id);
    axios
      .post(`${baseUrl}/seller/topup/stats`, fd ,{
        headers: {
          "Content-Type": "multipart/form-data",
           Authorization: `Bearer ${sellerAuthToken}`,
        },
      },)
      .then((res) => setStatsData(res.data))
      .catch(() => {});
  };

  useEffect(() => {
    viewAllTopUps();
    getStats();
    checkShop();
  }, []);

  const filteredHistory = getFilteredHistory();

  // currently selected method ka data nikaal lete hain
  const activeMethod = paymentMethods[paymentMethod];

  return (
    <SellerMasterLayout>
      <ToastContainer position="top-right" autoClose={3000} />

      <div className={`ser-shell-wrap ${isDark ? "dark-mode" : ""}`}>
        <main className="ser-main">
          <section className="ser-card-shell">
            {/* ── Stat Cards ── */}
            <div className="ser-overview">
              <div className="ser-overview-card">
                <div>
                  <span className="ser-overview-label">Wallet Balance</span>
                  <h3 className="ser-overview-value">
                    Rs {Number(statsData?.wallet_balance ?? 0).toLocaleString()}
                  </h3>
                  <p className="ser-overview-sub">Available funds</p>
                </div>
                <div className="ser-overview-icon">
                  <FiDollarSign />
                </div>
              </div>

              <div className="ser-overview-card">
                <div>
                  <span className="ser-overview-label">Total TopUps</span>
                  <h3 className="ser-overview-value">
                    {statsData?.total_topups ?? "0"}
                  </h3>
                  <p className="ser-overview-sub">All time requests</p>
                </div>
                <div className="ser-overview-icon">
                  <FiTrendingUp />
                </div>
              </div>

              <div className="ser-overview-card">
                <div>
                  <span className="ser-overview-label">
                    Total Commission Deducted
                  </span>
                  <h3 className="ser-overview-value ser-overview-value-danger">
                    Rs{" "}
                    {Number(
                      statsData?.total_commission_deducted ?? 0,
                    ).toLocaleString()}
                  </h3>
                  <p className="ser-overview-sub">
                    {PLATFORM_COMMISSION_PERCENT}% on completed orders
                  </p>
                </div>
                <div className="ser-overview-icon">
                  <FiTrendingDown />
                </div>
              </div>
            </div>

            {/* ── Header / Filters ── */}
            <div className="ser-header">
              <div className="ser-header-left" />
              <div className="ser-header-filters">
                <div className="ser-search">
                  <FiSearch size={15} />
                  <input
                    placeholder="Search topups"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                  {search && (
                    <button
                      className="ser-clear-input-btn"
                      onClick={() => setSearch("")}
                    >
                      <FiX size={12} />
                    </button>
                  )}
                </div>

                <select
                  className="ser-select"
                  value={statusFilter}
                  onChange={(e) => setStatusFilter(e.target.value)}
                >
                  {STATUS_OPTIONS.map((opt) => (
                    <option key={opt} value={opt}>
                      {opt}
                    </option>
                  ))}
                </select>

                <button
                  className="ser-topup-btn"
                  onClick={handleAddTopUpClick}
                >
                  <FiPlusCircle size={14} /> Add TopUp
                </button>
              </div>
            </div>

            {/* ── TopUp History Table ── */}
            <div className="ser-table-wrapper">
              <table className="ser-table">
                <thead>
                  <tr>
                    <th>TopUp ID</th>
                    <th>Date</th>
                    <th>Amount</th>
                    <th>Screenshot</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {loading && (
                    <tr>
                      <td colSpan="6" className="text-center py-4">
                        <Spinner
                          animation="border"
                          size="sm"
                          className="ser-spinner"
                          style={{ color: "#ff8559" }}
                        />
                        <span className="ms-2 ser-muted ser-loading-text">
                          Loading topups...
                        </span>
                      </td>
                    </tr>
                  )}

                  {!loading && filteredHistory.length === 0 && (
                    <tr>
                      <td colSpan="6" className="ser-no-results-row">
                        <div style={{ fontSize: "2rem" }}>💳</div>
                        <p className="ser-muted" style={{ marginTop: "8px" }}>
                          No topup history found
                        </p>
                      </td>
                    </tr>
                  )}

                  {!loading &&
                    filteredHistory.length > 0 &&
                    filteredHistory.map((item) => (
                      <tr key={item.id}>
                        <td className="ser-topup-id-cell">#{item.id}</td>
                        <td>
                          {new Date(item.created_at).toLocaleDateString(
                            "en-US",
                            {
                              month: "short",
                              day: "numeric",
                              year: "numeric",
                            },
                          )}
                        </td>
                        <td className="ser-amount-cell">
                          Rs {Number(item.amount).toLocaleString()}
                        </td>
                        <td>
                          {item.screenshot ? (
                            <img
                              src={`${baseUrlForFiles}/${item.screenshot}`}
                              alt="Payment proof"
                              className="ser-screenshot-thumb"
                            />
                          ) : (
                            <span className="ser-muted">No Image</span>
                          )}
                        </td>
                        <td>
                          <span
                            className={`ser-status-badge ${statusClasses[item.status]}`}
                          >
                            {item.status.charAt(0).toUpperCase() +
                              item.status.slice(1)}
                          </span>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </section>
        </main>
      </div>

      {/* ── TopUp Modal ── */}
      {showTopUpModal && (
        <div className="ser-modal-overlay" onClick={closeModal}>
          <div
            className="ser-modal ser-topup-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="ser-modal-header">
              <h3>TopUp Wallet</h3>
              <button className="ser-modal-close" onClick={closeModal}>
                <FiX />
              </button>
            </div>

            <div className="ser-modal-body">
              {/* payment method dropdown */}
              <div className="ser-modal-input-group">
                <label>Select Payment Method</label>
                <select
                  className="ser-payment-select"
                  value={paymentMethod}
                  onChange={(e) => setPaymentMethod(e.target.value)}
                >
                  {Object.entries(paymentMethods).map(([key, method]) => (
                    <option key={key} value={key}>
                      {method.label}
                    </option>
                  ))}
                </select>
              </div>

              {/* selected method ki detail */}
              <div className="ser-bank-details-box">
                <h5>
                  <FiDollarSign style={{ marginRight: "6px" }} />
                  Transfer to this {activeMethod.label}:
                </h5>
                {activeMethod.fields.map((field) => (
                  <div className="ser-bank-detail-row" key={field.label}>
                    <span>{field.label}</span>
                    <strong>{field.value}</strong>
                  </div>
                ))}
              </div>

              <div className="ser-modal-input-group">
                <label>Attach Payment Screenshot</label>
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => setScreenshot(e.target.files[0])}
                />
              </div>

              <div className="ser-modal-input-group">
                <label>Enter TopUp Amount (Rs)</label>
                <input
                  type="number"
                  placeholder="Enter amount you transferred"
                  value={topUpAmount}
                  onChange={(e) => setTopUpAmount(e.target.value)}
                  min="100"
                />
                <span className="ser-input-hint">Minimum TopUp: Rs 1000</span>
              </div>

              <div className="ser-modal-alert">
                <FiAlertCircle />
                <div className="ser-modal-alert-lines">
                  <span>
                    After submitting, admin will verify your payment and credit
                    the amount to your wallet within 24 hours.
                  </span>
                  <span className="ser-modal-alert-commission">
                    <strong>Note:</strong> A {PLATFORM_COMMISSION_PERCENT}%
                    platform commission will be deducted from your wallet
                    balance on every order placed.
                  </span>
                </div>
              </div>
            </div>

            <div className="ser-modal-footer">
              <button className="ser-modal-btn-cancel" onClick={closeModal}>
                Cancel
              </button>
              <button
                className="ser-modal-btn-confirm"
                onClick={handleTopUpSubmit}
                disabled={submitting}
              >
                {submitting ? "Submitting..." : "Submit TopUp Request"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ── Shop Guard Modal ── */}
      {shopGuardModal && (
        <div
          className="ser-guard-overlay"
          onClick={() => setShopGuardModal(false)}
        >
          <div className="ser-guard-modal" onClick={(e) => e.stopPropagation()}>
            <div className="ser-guard-icon-wrap">
              <div className="ser-guard-ring ser-guard-ring--1" />
              <div className="ser-guard-ring ser-guard-ring--2" />
              <div
                className={`ser-guard-icon-circle ${shopGuardType === "pending" ? "ser-guard-icon-circle--amber" : ""}`}
              >
                <span className="ser-guard-emoji">
                  {shopGuardType === "pending" ? "⏳" : "🏪"}
                </span>
              </div>
            </div>
            <button
              className="ser-guard-close"
              onClick={() => setShopGuardModal(false)}
            >
              <FiX size={15} />
            </button>
            <h2 className="ser-guard-title">
              {shopGuardType === "pending"
                ? "Shop Awaiting Approval"
                : "Set Up Your Shop First"}
            </h2>
            <p className="ser-guard-text">
              {shopGuardType === "pending"
                ? "Your shop is currently under review by our admin team. You'll be able to top up your wallet as soon as your shop is approved."
                : "You haven't created your shop yet. Please set up your shop profile before requesting a top up."}
            </p>
            {shopGuardType === "no-shop" && (
              <button
                className="ser-guard-btn-confirm"
                onClick={() => {
                  setShopGuardModal(false);
                  navigate("/seller/editstore");
                }}
              >
                Create My Shop <FiArrowRight size={14} />
              </button>
            )}
            <button
              className="ser-guard-btn-cancel"
              onClick={() => setShopGuardModal(false)}
            >
              {shopGuardType === "pending" ? "Got it" : "Maybe later"}
            </button>
          </div>
        </div>
      )}
    </SellerMasterLayout>
  );
};

export default SellerEarningsManagement;